import { Button, Group, Modal, Text } from "@mantine/core";
import { useLanguage } from "../../stores/LanguageStore";
import { IconShare, IconShare3 } from "@tabler/icons-react";
import { useDisclosure } from "@mantine/hooks";
import { useForm } from "react-hook-form";
import SharingController from "../Sharing/SharingController";
import { useState } from "react";
import { notifications } from "@mantine/notifications";

const ItemSharer = ({ handleShare, getEditFunction, onFinish, current }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, { open, close }] = useDisclosure();
  const [loading, setLoading] = useState(false);

  const sharingForm = useForm({
    defaultValues: {
      sharing: current["stats_sharings"]?.map((x) => ({
        ...x,
        sharing_targets: x?.sharing_targets?.map((sharing_target) => ({
          ...sharing_target,
          option_name: sharing_target.name,
        })),
      })),
    },
  });

  const main = () => {
    setLoading(true);

    const newSharing = sharingForm
      .getValues()
      .sharing.filter((x) => x.sharing_targets.length > 0)
      .map((share) => ({
        ...share,
        name: "multiple",
        ids_list: share.sharing_targets.map((x) => x.id),
        sharing_targets: share.sharing_targets.map((x) => ({
          ...x,
          name: x.option_name,
        })),
      }));

    let editFunction = getEditFunction ? getEditFunction(current) : handleShare;
    editFunction({
      id: current.id,
      sharing: [...(current?.sharing || []), ...newSharing],
    }).then((res) => {
      notifications.show({
        message: lang.table.toolbar.bulk_share.success_unique,
        color: "green.8",
      });
      close();
      setLoading(false);
      onFinish?.();
    });
  };

  return (
    <>
      <Button
        onClick={open}
        leftSection={<IconShare3 size={18} />}
        color="primary"
        variant="subtle"
        justify="start"
        disabled={
          !current?.write_permission &&
          !current?.permission?.write_permission}
      >
        {lang.table.toolbar.bulk_share.button_label}
      </Button>

      <Modal
        opened={opened}
        onClose={close}
        title={
          <Text size="md" truncate="end">
            {lang.table.toolbar.bulk_share.button_label} <b> {current?.name}</b>
          </Text>
        }
        size={"60%"}
        centered
        styles={{
          title: {
            maxWidth: "92%",
          },
        }}
      >
        <SharingController form={sharingForm} />

        <Group justify="end" mt={"sm"}>
          <Button variant="subtle" onClick={close}>
            {lang.components.deletion_action.dialog.cancel_button}
          </Button>
          <Button
            onClick={main}
            leftSection={<IconShare size={18} />}
            loading={loading}
          >
            {lang.table.toolbar.bulk_share.submit_button}
          </Button>
        </Group>
      </Modal>
    </>
  );
};

export default ItemSharer;
